//** Import Modules */
import { Helmet } from "react-helmet";
import { Button, Result } from "antd";
import PageTitle from "../../components/header/PageTitle";

export default function NotFound() {
  return (
    <div>
      <Helmet>
        <title>Page Not Found</title>
        <meta name='description' content='Page Not Found' />
      </Helmet>
      <PageTitle pageTitle='404 - Page Not Found' />
      <div className="inner-container">
        <Result
          status="404"
          title="We couldn't find that page"
          subTitle="The link may be outdated or the page may have moved. Head home to keep exploring Bizzll."
          extra={
            <Button type="primary" size="large" href="/">
              Back to home
            </Button>
          }
        />
      </div>
    </div>
  );
}
